import { useTranslation } from 'react-i18next';
import { i18nDynamic } from 'shared/i18n';
import { Typography } from 'app/components/ui';

interface AccordionHeaderProps {
  title: string;
  result: string;
  details?: string;
}

const AccordionHeader = ({ title, result, details }: AccordionHeaderProps) => {
  // Subscribes this component to language changes. i18nDynamic reads i18next directly and
  // does not, so without the hook the label below would go stale after a language switch.
  useTranslation();

  return (
    <div className="tag-accordion-header">
      <Typography variant="body-7" fontWeight="bold">
        {title}
      </Typography>

      <Typography variant="body-7" fontWeight="semibold" className="caps" color={result === 'passed' ? '#70DA74' : '#D9534F'}>
        {i18nDynamic(`tag:validation.result.${result}`)}
      </Typography>

      {details && (
        <Typography variant="body-5" fontWeight="semibold" color={details.includes('error') ? '#D9534F' : details.includes('warning') ? '#F0AD4E' : undefined}>
          {details}
        </Typography>
      )}
    </div>
  );
};

export { AccordionHeader };
